import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import defaultFlowConfig from "./config/flowConfig.json";

const defaultLanguageLoader = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const shopRegion = queryParams.get("shop");
  if (!["de", "nl"].includes(shopRegion)) {
    return "de";
  } else return shopRegion;
};

const resources = {
  en: {
    homeModule: require("./locales/en/homeModule.json"),
    scanModule: require("./locales/en/scanModule.json"),
    questionsModule: require("./locales/en/questionsModule.json"),
    aiResults: require("./locales/en/aiResults.json"),
    recommendation: require("./locales/en/recommendation.json"),
    customAiInfo: require("./locales/en/customAiInfo.json"),
    customHomeInfo: require("./locales/en/customHomeInfo.json"),
    customQuestions: require("./locales/en/customQuestions.json"),
    errorPage: require("./locales/en/errorPage.json"),
    geoBlockPage: require("./locales/en/geoBlockPage.json"),
  },
  de: {
    homeModule: require("./locales/de/homeModule.json"),
    scanModule: require("./locales/de/scanModule.json"),
    questionsModule: require("./locales/de/questionsModule.json"),
    aiResults: require("./locales/de/aiResults.json"),
    recommendation: require("./locales/de/recommendation.json"),
    customAiInfo: require("./locales/de/customAiInfo.json"),
    customHomeInfo: require("./locales/de/customHomeInfo.json"),
    customQuestions: require("./locales/de/customQuestions.json"),
    errorPage: require("./locales/de/errorPage.json"),
    geoBlockPage: require("./locales/de/geoBlockPage.json"),
  },
  nl: {
    homeModule: require("./locales/nl/homeModule.json"),
    scanModule: require("./locales/nl/scanModule.json"),
    questionsModule: require("./locales/nl/questionsModule.json"),
    aiResults: require("./locales/nl/aiResults.json"),
    recommendation: require("./locales/nl/recommendation.json"),
    customAiInfo: require("./locales/nl/customAiInfo.json"),
    customHomeInfo: require("./locales/nl/customHomeInfo.json"),
    customQuestions: require("./locales/nl/customQuestions.json"),
    errorPage: require("./locales/nl/errorPage.json"),
    geoBlockPage: require("./locales/nl/geoBlockPage.json"),
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: resources,
    lng: defaultLanguageLoader(),
    supportedLngs: defaultFlowConfig.availableLanguages,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
